var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 11.75C6.80964 11.75 6.25 12.3096 6.25 13V19C6.25 19.6904 6.80964 20.25 7.5 20.25H17.5C18.1904 20.25 18.75 19.6904 18.75 19V13C18.75 12.3096 18.1904 11.75 17.5 11.75H7.5ZM4.75 13C4.75 11.4812 5.98122 10.25 7.5 10.25H17.5C19.0188 10.25 20.25 11.4812 20.25 13V19C20.25 20.5188 19.0188 21.75 17.5 21.75H7.5C5.98122 21.75 4.75 20.5188 4.75 19V13Z",
    fill: "#323B49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 16C10.5 14.8954 11.3954 14 12.5 14C13.6046 14 14.5 14.8954 14.5 16C14.5 17.1046 13.6046 18 12.5 18C11.3954 18 10.5 17.1046 10.5 16Z",
    fill: "#323B49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3.75C11.638 3.75 10.8114 4.09241 10.2019 4.7019C9.59241 5.3114 9.25 6.13805 9.25 7V11C9.25 11.4142 8.91421 11.75 8.5 11.75C8.08579 11.75 7.75 11.4142 7.75 11V7C7.75 5.74022 8.25044 4.53204 9.14124 3.64124C10.032 2.75044 11.2402 2.25 12.5 2.25C13.7598 2.25 14.968 2.75044 15.8588 3.64124C16.7496 4.53204 17.25 5.74022 17.25 7V11C17.25 11.4142 16.9142 11.75 16.5 11.75C16.0858 11.75 15.75 11.4142 15.75 11V7C15.75 6.13805 15.4076 5.3114 14.7981 4.7019C14.1886 4.09241 13.362 3.75 12.5 3.75Z",
    fill: "#323B49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.f537a245cb6c6b6a3347e4488df7a980.svg";
export { ForwardRef as ReactComponent };